/**
 * Canonical key for price-memory matching: trim, collapse internal whitespace
 * to one space, lowercase. Product names are stored inconsistently across
 * накладные (MoySklad verbatim, manual trimmed), so lookups normalize both
 * sides. MUST byte-match the backend copy in
 * apps/backend/src/moysklad/shipment-math.ts → normalizeName.
 */
export function normalizeName(name: string): string {
  return name.trim().replace(/\s+/g, ' ').toLowerCase();
}
